import {BRANDS, LOGIN_CASES, LANGUAGES} from 'const'
import {getDefaultConfig, getFavicon, getFooterLogosByBrandList, getHeaderLogo} from '../commonHelper'
import config from 'config'
import {isProd} from 'utils/envUtils'
import {getLang} from 'utils/stringUtils'
import {FOOTER_LOGO_TYPES} from 'const/logos'

const brandUrl = 'https://www.jobs.ch/'
const otherBrandsLogos = getFooterLogosByBrandList([BRANDS.jobs, BRANDS.jobup, BRANDS.twentymin, BRANDS.tagesanzeiger])
const OPEN_SAUCE_REGULAR_FONT = "'Open Sauce Two Regular', Helvetica, Arial, sans-serif"
const OPEN_SAUCE_BOLD_FONT = "'Open Sauce Two Bold', Helvetica, Arial, sans-serif"

const lang = getLang(window.location.search) || LANGUAGES.DE
const authorizeRedirectURL = `https://www${
  isProd() ? '' : '.stage'
}.jobs.ch/${lang}/redirect-to-login/?authSource=password_reset`

export default {
  brand: {
    url: brandUrl,
    name: BRANDS.jobs,
    favicon: getFavicon(BRANDS.jobs),
    fontColor: '#ffffff',
    support: 'https://www.jobs.ch/de/job-coach/faqs/',
    authorizeRedirectURL,
  },
  config: {
    ...getDefaultConfig(),
    onePager: ({loginCase}) => [LOGIN_CASES.EMAIL_ONLY, LOGIN_CASES.DEFAULT].includes(loginCase),
    subtitleWithFAQLanding: true,
    useCircularSocialLogin: true,
  },
  otherBrandsLogos,
  fontConfig: {
    custom: {
      urls: [`${config.url}/fonts/jobs/index.css`],
    },
  },
  separator: {
    background: '#D8D8D8',
    family: OPEN_SAUCE_BOLD_FONT,
    fontWeight: 'bold',
    color: '#222222',
    fontSize: '14px',
    height: '1px',
    lineHeight: '22px',
    portraitMargin: '24px 0 28px 0',
    transform: 'none',
  },
  shell: {
    header: {
      color: '#FFF',
      backgroundColor: '#004099',
      height: {
        default: '80px',
        onScroll: '56px',
        withEmail: '102px',
      },
      poweredLogo: {
        src: 'logo-onelog-poweredby-white.png',
      },
      logo: {
        height: {
          default: '20px',
          small: '20px',
          onScroll: '20px',
        },
        src: {
          default: getHeaderLogo(BRANDS.jobs),
        },
      },
      languageSwitcher: {
        color: '#FFF',
        activeColor: '#021a67',
        backgroundColor: '#FFFFFF',
        menu: {
          fontSize: '16px',
          lineHeight: '22px',
          color: '#000',
          hoverBackgroundColor: '#CFD3E3',
        },
      },
      menu: {
        default: {
          color: '#FFF',
          fontSize: '16px',
        },
        active: {
          color: '#FFFFFF',
          backgroundColor: '#004099',
          hoverBackgroundColor: '#021a67',
          selectedBackgroundColor: '#021a67',
          separatorColor: '#FFF',
        },
      },
    },
    footer: {
      tenants: {
        logoColor: FOOTER_LOGO_TYPES.dark,
        color: '#373737',
        hoverColor: '#2884E2',
        backgroundColor: '#E6E6E6',
        fontSize: '12px',
        lineHeight: '18px',
        separatorColor: '#cdd5db',
      },
      copyright: {
        color: '#373737',
        hoverColor: '#2884e2',
        backgroundColor: '#F5F5F5',
        fontSize: '12px',
        lineHeight: '18px',
        separatorColor: '#cdd5db',
      },
    },
  },
  ringierBanner: {
    backgroundColor: '#F5F5F5',
    fontSize: '14px',
    lineHeight: '20px',
    linkColor: '#373737',
    linkFontSize: '12px',
    linkHoverColor: '#373737',
    benefitMessageColor: '#222222',
    titleFontSize: '14px',
    landscape: {
      fontSize: '14px',
      titleFontSize: '14px',
    },
    titleFontWeight: 'bold',
    titleFontFamily: OPEN_SAUCE_BOLD_FONT,
    onelogTitle: {
      fontSize: '12px',
      fontWeight: '600',
      lineHeight: '16px',
      color: '#222222',
      fontFamily: OPEN_SAUCE_BOLD_FONT,
      margin: '0 0 20px 0',
    },
    onelogSection: {
      padding: '40px 0 0 0',
      borderTop: '1px solid #8F8F8F',
    },
    benefitsIcon: `${config.url}/assets/SI-icon-check-banner.svg`,
    padding: '20px',
    iconWidth: '24px',
    iconHeight: '24px',
    borderRadius: '24px',
  },
  font: {
    family: OPEN_SAUCE_REGULAR_FONT,
    fontWeight: 'normal',
    boldFamily: OPEN_SAUCE_BOLD_FONT,
    boldFontWeight: 'bold',
    size: '14px',
    height: '20px',
    mobile: {
      size: '16px',
      height: '24px',
    },
    portrait: {
      size: '16px',
      height: '24px',
    },
    color: {
      dark: '#222222',
      light: '#FFFFFF',
    },
  },
  logisterSection: {
    registerMarginTop: '20px',
    registerWeight: 300,
    subheaderBorderTop: '1px solid #d9d9d9',
    subheaderPadding: '12px 20px',
    subheaderFamily: OPEN_SAUCE_REGULAR_FONT,
    subheaderFontSize: '14px',
    subheaderLineHeight: '20px',
    subheaderTitleColor: '#222222',
    subheaderTitleMargin: '0 0 4px 0',
    subheaderLinkColor: '#222222',
    subheaderLinkHoverColor: '#292E32',
    subheaderBackgroundColor: '#F6F6F6',
    registerSize: '14px',
    noteColor: '#8F8F8F',
    noteFontSize: {
      default: '14px',
      portrait: '14px',
    },
    subtitle: {
      color: '#222222',
      lineHeight: '22px',
      margin: '-12px 0 12px',
      fontSize: {
        default: '14px',
        portrait: '14px',
      },
      link: {
        color: '#222222',
        hoverColor: '#222222',
      },
    },
    title: {
      textChangeBreakpoint: 'mobile',
      fontSize: {
        smallMobile: '24px',
        mobile: '24px',
        portrait: '24px',
        landscape: '32px',
        desktop: '32px',
      },
      lineHeight: {
        smallMobile: '30px',
        mobile: '28px',
        portrait: '28px',
        landscape: '34px',
        desktop: '34px',
      },
    },
  },
  buttons: {
    height: '50px',
    primary: {
      border: 0,
      color: '#FFFFFF',
      background: '#004099',
      hoverBorder: 0,
      hoverBackground: '#021A67',
      focusBorder: '2px solid #021A67',
      focusBoxShadow: 'inset 1px 1px 1px #ffffff, inset -1px -1px 1px #ffffff',
      focusBackground: '#004099',
      activeBorder: 0,
      activeBackground: '#021A67',
      isAnimated: true,
      fontSize: '16px',
      textStyles: {
        weight: 400,
        family: OPEN_SAUCE_REGULAR_FONT,
      },
    },
    secondary: {
      border: '1px solid #004099',
      color: '#004099',
      background: '#FFFFFF',
      hoverBorder: '1px solid #032E83',
      hoverColor: '#004099',
      hoverBackground: '#F5FBFE',
      focusBorder: '2px solid #032E83',
      focusBackground: '#FFFFFF',
      activeBorder: '1px solid #032E83',
      activeColor: '#004F61',
      activeBackground: '#F5FBFE',
      fontSize: '16px',
      dotsColor: '#004099',
    },
    disabled: {
      border: 0,
      color: '#6A6E71',
      background: '#F5F5F5',
      hoverBorder: 0,
      hoverBackground: '#F5F5F5',
      activeBorder: 0,
      activeBackground: '#F5F5F5',
    },
    touchId: {
      border: 0,
      color: '#FFFFFF',
      background: '#004099',
      hoverBorder: 0,
      hoverBackground: '#021A67',
      focusBorder: '2px solid #021A67',
      focusBoxShadow: 'inset 1px 1px 1px #ffffff, inset -1px -1px 1px #ffffff',
      focusBackground: '#004099',
      activeBorder: 0,
      activeBackground: '#021A67',
      isAnimated: true,
      full: true,
      icon: 'icon-touchid.svg',
      iconStyles: {padding: '12px', marginLeft: '0'},
      descriptionStyles: {
        fontFamily: OPEN_SAUCE_REGULAR_FONT,
      },
      textStyles: {
        size: '14px',
      },
    },
    faceId: {
      border: 0,
      color: '#FFFFFF',
      background: '#004099',
      hoverBorder: 0,
      hoverBackground: '#021A67',
      focusBorder: '2px solid #021A67',
      focusBoxShadow: 'inset 1px 1px 1px #ffffff, inset -1px -1px 1px #ffffff',
      focusBackground: '#004099',
      activeBorder: 0,
      activeBackground: '#021A67',
      isAnimated: true,
      full: true,
      icon: 'icon-faceid.svg',
      iconStyles: {padding: '12px', marginLeft: '0'},
      descriptionStyles: {
        fontFamily: OPEN_SAUCE_REGULAR_FONT,
      },
      textStyles: {
        size: '14px',
      },
    },
    anyId: {
      border: 0,
      color: '#FFFFFF',
      background: '#004099',
      hoverBorder: 0,
      hoverBackground: '#021A67',
      focusBorder: '2px solid #021A67',
      focusBoxShadow: 'inset 1px 1px 1px #ffffff, inset -1px -1px 1px #ffffff',
      focusBackground: '#004099',
      activeBorder: 0,
      activeBackground: '#021A67',
      isAnimated: true,
      full: true,
      icon: 'icon-touchid.svg',
      iconStyles: {padding: '12px', marginLeft: '0'},
      descriptionStyles: {
        fontFamily: OPEN_SAUCE_REGULAR_FONT,
      },
      textStyles: {
        size: '14px',
      },
    },
    icon: {
      height: '24px',
      width: '24px',
    },
    text: {
      family: OPEN_SAUCE_BOLD_FONT,
      boldFamily: OPEN_SAUCE_BOLD_FONT,
      color: '#004056',
      size: '16px',
    },
    border: {
      radius: '32px',
    },
    linkOnSecondLine: true,
    dotsColor: '#FFFFFF',
  },
  title: {
    family: OPEN_SAUCE_BOLD_FONT,
    size: '28px',
    height: '32px',
    mobile: {
      size: '28px',
      height: '32px',
    },
    portrait: {
      size: '32px',
      height: '36px',
    },
    weight: '600',
  },
  input: {
    background: '#FFFFFF',
    color: '#222222',
    borderBottom: '1px solid #CDCDCD',
    errorBackground: '#FFFFFF',
    errorBorderBottom: '1px solid #E2211B',
    hoverBorderBottom: '1px solid #2884E2',
    focusBorderBottom: '1px solid #004099',
    padding: '8px 12px',
    fontFamily: OPEN_SAUCE_REGULAR_FONT,
    border: '1px solid #CDCDCD',
    errorBorder: '1px solid #E2211B',
    hoverBorder: '1px solid #2884E2',
    focusBorder: '1px solid #004099',
    borderRadius: '8px',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    height: '50px',
    email: {
      color: '#757575',
      backgroundColor: '#F5F5F5',
      border: '0',
      borderRadius: '8px',
      button: {
        height: '28px',
        right: '12px',
        backgroundColor: '#FFFFFF',
        width: '70px',
        color: '#004099',
        fontFamily: OPEN_SAUCE_REGULAR_FONT,
        fontSize: '14px',
        textDecoration: 'none',
        border: '1px solid #004099',
        borderRight: '1px solid #004099',
        borderRadius: '8px',
        hoverColor: '#2884E2',
        hoverBorder: '1px solid #2884E2',
        hoverBackgroundColor: '#F5FBFE',
        hoverBorderRight: '1px solid #2884E2',
        hoverFamily: OPEN_SAUCE_REGULAR_FONT,
      },
    },
    password: {
      color: '#004099',
      hoverColor: '#2884E2',
      size: '14px',
      height: '18px',
      top: '16px',
    },
    loading: {
      top: '7px',
    },
    placeholder: {
      color: '#A3A3A3',
      fontSize: '16px',
      lineHeight: '24px',
    },
  },
  edging: {
    borderRadius: '24px',
  },
  field: {
    label: {
      color: '#222222',
      fontSize: '12px',
      family: OPEN_SAUCE_REGULAR_FONT,
      boldFamily: OPEN_SAUCE_BOLD_FONT,
      disabledColor: 'rgba(31,31,31,0.6)',
      fontHeight: '20px',
      fontWeight: '400',
    },
    error: {
      background: 'inherit',
      fontColor: '#E2211B',
      size: '12px',
      height: '20px',
      padding: '4px 20px 0',
      margin: '0 -20px',
    },
    optional: {
      fontSize: '12px',
      color: '#A3A3A3',
    },
    edging: {
      backgroundColor: '#F7F7F7',
    },
  },
  link: {
    default: '#004099',
    hoverColor: '#2884E2',
    infoHoverColor: '#004F61',
    secondary: '#004099',
    secondaryHover: '#2884E2',
    isAgreementsLink: true,
    agreement: '#373737',
    textDecorationHover: 'underline',
    align: 'left',
  },
  secondaryFont: {
    size: '16px',
    height: '24px',
    mobile: {
      size: '16px',
      height: '24px',
    },
    portrait: {
      size: '16px',
      height: '24px',
      backlink: '12px',
    },
  },
  note: {
    lightColor: '#373737',
    family: OPEN_SAUCE_REGULAR_FONT,
    lightFamily: OPEN_SAUCE_REGULAR_FONT,
    fontSize: '16px',
    fontWeight: '700',
    lightFontWeight: '400',
    termsText: {
      fontSize: '12px',
      lineHeight: '18px',
    },
  },
  notification: {
    family: '',
    success: '#4B820D',
    error: '#E2211B',
    pageError: '#E2211B',
    warning: '#F6CA04',
    info: '#2884E2',
    icon: {
      width: '24px',
      height: '24px',
      mobile: {
        width: '32px',
        height: '32px',
      },
    },
    pageMessage: {
      size: '14px',
      height: '22px',
      borderRadius: '8px',
      colorFunc: () => '#FFFFFF',
    },
  },
  form: {
    border: '',
    background: '#F7F7F7',
    fieldBackground: '',
    padding: '0 0 20px 0',
    sectionViewBackground: '#f8f8f8',
    marginBottom: '0',
    loginSubmitMarginTop: '0',
    note: {
      fontSize: '20px',
    },
  },
  logisterForm: {
    border: '',
    background: '',
    padding: '',
    submitButton: 'primary',
    forgetLinkFloat: 'right',
  },
  loginForm: {
    forgetLink: {
      wrapper: {
        defaultMarginBottom: '20px',
        errorMarginBottom: '22px',
      },
      link: {
        fontSize: '12px',
        marginTop: '6px',
        color: '#004099',
      },
    },
  },
  registerPage: {
    backLinkMargin: {
      default: '0 0 12px',
      portrait: '0 0 12px',
    },
    titleMargin: {
      default: '0 0 20px',
      portrait: '0 0 20px',
    },
    submitButtonMarginTop: 0,
  },
  emailVerifyPage: {
    linkMarginBottom: '10px',
    subtitleFontSize: '16px',
    note: {
      fontFamily: OPEN_SAUCE_BOLD_FONT,
      fontSize: '14px',
    },
    message: {
      fontSize: '14px',
    },
    link: {
      color: '#004099',
      fontSize: '14px',
    },
  },
  textarea: {
    height: '96px',
  },
  checkbox: {
    icon: {
      height: '20px',
      width: '20px',
      top: '3px',
      right: '12px',
      image: 'brands/jobs/form/checkbox.svg',
      checkedImage: 'brands/jobs/form/checkbox-checked.svg',
      hoverImage: 'brands/jobs/form/checkbox-hover.svg',
      errorImage: 'brands/jobs/form/checkbox-error.svg',
      disabledImage: 'brands/jobs/form/checkbox-disabled.svg',
    },
    errorMargin: '',
    padding: '16px 20px',
    labelFontHeight: '24px',
    labelColor: '#292E32',
    group: {
      label: {
        marginBottom: '8px',
        padding: '0',
        backgroundColor: '',
      },
      marginBottom: '20px',
      padding: '0 20px',
      backgroundColor: '#F9F9F9',
      fontWeight: '400',
      fontSize: '18px',
      note: {
        fontWeight: '300',
        fontSize: '16px',
        marginLeft: '32px',
        color: '#292E32',
      },
    },
    errorPadding: '4px 20px 0',
  },
  select: {
    fontFamily: OPEN_SAUCE_REGULAR_FONT,
    icon: {
      width: '16px',
      height: '16px',
      image: 'brands/cash/icon-arrow-down.svg',
      focusImage: 'brands/cash/icon-arrow-down.svg',
      alt_image: 'brands/cash/icon-arrow-down.svg',
    },
    menu: {
      border: '1px solid #E1E8F1',
      isCheckIconVisible: false,
      checkIcon: 'NRJ-check-form-grey.svg',
      color: '#292E32',
      option: {
        color: '#292E32',
        fontFamily: OPEN_SAUCE_REGULAR_FONT,
        padding: '4px 20px',
        focusBorder: '0',
        focusBackground: '#F5F5F5',
        focusColor: '#292E32',
        selectedFontFamily: OPEN_SAUCE_BOLD_FONT,
      },
      placeholder: {
        color: '#A3A3A3',
      },
      singleValue: {
        color: '#292E32',
      },
    },
    dropdownIndicator: {
      padding: '0',
    },
  },
  radio: {
    icon: {
      width: '20px',
      height: '20px',
      image: 'brands/jobs/form/radio.svg',
      checkedImage: 'brands/jobs/form/radio-active.svg',
      hoverImage: 'brands/jobs/form/radio-hover.svg',
      errorImage: 'brands/jobs/form/radio-error.svg',
      disabledImage: 'brands/jobs/form/radio-disabled.svg',
    },
    errorMargin: '0 -20px 0px',
    labelFontHeight: '24px',
    labelMarginBottom: '8px',
    fontSize: '16px',
    color: '#222222',
  },
  errorPage: {
    font: {
      height: '18px',
      portrait: {
        height: '30px',
      },
    },
  },
  inputNote: {color: '#757575', size: '12px', height: '20px', marginTop: '4px'},
  tab: {
    fontSize: '18px',
    desktop: {focusBorder: 'solid 4px #292E32', bottomMargin: '-4px', height: '80px'},
    mobile: {icon: {border: 'solid 2px #ACACAC', width: '14px', height: '14px', color: '#292E32'}},
  },
  consent: {
    subtitle: {
      marginBottom: '8px',
    },
    checkbox: {
      marginBottom: '20px',
      paddingBottom: '',
    },
    agreements: {
      color: '#373737',
    },
  },
  mobileNumber: {
    label: {
      marginBottom: '20px',
    },
    subtitle: {
      marginTop: '8px',
      color: '#292E32',
    },
    select: {
      padding: '8px 0px 8px 12px',
      backgroundColor: '#FFFFFF',
      borderRight: '1px solid #D8D8D8',
      hoverBorderRight: '1px solid #D8D8D8',
      focusBorderRight: '1px solid #D8D8D8',
      errorBorderRight: '1px solid #D8D8D8',
    },
    selectIcon: {
      padding: '0px 12px',
    },
    input: {
      backgroundColor: '#FFFFFF',
      errorBackgroundColor: '#FFFFFF',
      padding: '8px 12px',
    },
    code: {
      letterSpacing: '7px',
      paddingLeft: {
        normal: 'calc(50% - 50px)',
        error: 'calc(50% - 51px)',
      },
      underline: {
        left: 'calc(50% - 20px)',
        top: 'calc(50% - 7px)',
      },
    },
    questionLabel: {
      family: OPEN_SAUCE_BOLD_FONT,
      color: '#292E32',
    },
    link: {
      fontSize: '14px',
      lineHeight: '20px',
      fontFamily: OPEN_SAUCE_REGULAR_FONT,
    },
    verifiedLabel: {
      color: '#292E32',
    },
    container: {
      marginBottom: '15px',
    },
  },
  address: {
    padding: '20px 20px 0px 20px',
    inputBackgroundColor: '#F7F7F7',
    formFieldMarginBottom: '',
    checkboxPadding: '0px 0px 20px 0px',
    link: {
      fontSize: '14px',
      lineHeight: '20px',
    },
    control: {
      fontSize: '16px',
      fontFamily: OPEN_SAUCE_REGULAR_FONT,
      lineHeight: '24px',
    },
  },
  mfa: {
    inputPadding: '12px',
    subtitleFontSize: '16px',
    textFontSize: '14px',
    link: {
      color: '#004099',
      hoverColor: '#2884E2',
    },
  },
  webauthn: {
    dropdown: {
      fontSize: '14px',
      color: '#004099',
      hoverColor: '#2884E2',
    },
  },
  languageSwitcher: {
    menuColor: '#FFFFFF',
    fontRegular: OPEN_SAUCE_REGULAR_FONT,
    fontSemiBold: OPEN_SAUCE_REGULAR_FONT,
    fontBold: OPEN_SAUCE_BOLD_FONT,
    menuIcon: 'OL-icon-arrow-down-white.svg',
    menuOnHover: `font-family: ${OPEN_SAUCE_BOLD_FONT}`,
    listItemActiveColor: '#222222',
    listItemHoverTextColor: '#ffffff',
    listItemDefaultColor: '#222222',
    listItemHoverColor: '#004099',
    listItemLineHeight: '36px',
    listItemFontSize: '16px',
    switcherListBorder: '1px solid #004099',
    profileMenuIcon: 'OL-icon-arrow-down-white.svg',
    profileMenuColor: '#FFFFFF',
    profileMenuFont: '',
  },
}
